var render = function render(_c,_vm){return _c('div',{staticClass:"mt-1 text-sm",class:{
    'text-red-500': _vm.props.danger,
    'text-green-500': _vm.props.success,
    'text-teal-500': _vm.props.info,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }